/// <reference path="../types/index.d.ts" />

import '../client_forms/tcavenuewed/style.css';
import FormStructure from './tcavenuewed/form_structure';

export default FormStructure;